module.exports = __webpack_public_path__ + "img/menu-banner-integritas-assist.9f118891.png";